import {
    NotificationContainer,
    NotificationMessage,
    NotificationTitle
} from "components/shared/Notifications/elements";
import React, { FC, useEffect, useRef } from "react";
import SuccessIcon from "svg/icon-check.svg";
import ErrorIcon from "svg/error-icon.svg";
import { ToastData } from "components/shared/Notifications/ToastContext";

const NotificationIcons = {
    Success: <SuccessIcon />,
    Error: <ErrorIcon data-testid="error-icon" />
};

type Props = OptionalExceptFor<ToastData, "title" | "message" | "positions"> & {
    // remove already has the id set inside when it's passed in
    remove: () => void;
};

export const Toast: FC<Props> = ({
    title,
    message,
    remove,
    type = "Success",
    duration = 3000,
    positions
}) => {
    const removeRef = useRef(remove);

    useEffect(() => {
        const id = setTimeout(() => removeRef.current(), duration);

        return () => clearTimeout(id);
    }, []);

    return (
        <NotificationContainer positions={positions} type={type}>
            {NotificationIcons[type]}
            <NotificationTitle>{title}</NotificationTitle>
            <NotificationMessage>{message}</NotificationMessage>
        </NotificationContainer>
    );
};
